export default "/images/vendor/flag-icon-css/flags/4x3/es-ca.svg?2b2d073d58c4747e322ef8e48b09beca";